export default __webpack_public_path__ + "static/home-card-profession-has-no-gender-e4ae60309173c160bd2f02f8c3ad6105.svg";